import WelcomeBonus from './WelcomeBonus';
import { connect } from '../../node_modules/react-redux';
import { addCoins as _addCoins } from '../../state/actions/extras';
import { setIsWelcomeBonusConsumed as _setIsWelcomeBonusConsumed } from '../../state/actions/consumables';

var mapStateToProps = function mapStateToProps(state) {
  return {
    welcomeBonus: state.consumables.welcomeBonus,
    shouldCollectWelcomeBonus: !state.consumables.isWelcomeBonusConsumed && !state.load.initAppResponse.TUTORIAL,
    actionCommands: state.actionCommands.actions[0]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addCoins: function addCoins(value) {
      dispatch(_addCoins(value));
    },
    setIsWelcomeBonusConsumed: function setIsWelcomeBonusConsumed(value) {
      dispatch(_setIsWelcomeBonusConsumed(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeBonus);